import {isAxiosError} from "axios";
import {CONTRACT_TYPES, ENTITY_TYPE_CONTRACT, ENTITY_TYPE_QUOTE} from "~/constants/contracts";
import {QUOTE_TYPES} from "~/constants/quotes";
import type {Contract, FullContract} from '~/models/contract'

const getEntityTypes = (entityType: number) => {
    switch (entityType) {
        case ENTITY_TYPE_QUOTE:
            return QUOTE_TYPES;
        case ENTITY_TYPE_CONTRACT:
        default:
            return CONTRACT_TYPES;
    }
}


export const getEntityLabelConfig = (entityType?: number, type?: number) => {
    const TYPES = getEntityTypes(entityType || ENTITY_TYPE_CONTRACT)
    const selectedType = TYPES.find((s) => s.Id === type);
    if(selectedType) {
        return selectedType || null;
    }
    return null;
}

export const getNewEntityLabelKey = (entityType?: number = ENTITY_TYPE_CONTRACT) => {
    switch (entityType) {
        case ENTITY_TYPE_QUOTE:
            return 'NEW_QUOTE';
        case ENTITY_TYPE_CONTRACT:
        default:
            return 'NEW_CONTRACT';
    }
}

export const isQuote = (contract: Contract | FullContract): boolean => {
    const c = contract as FullContract & {EntityType?: number}
    return c.EntityType === ENTITY_TYPE_QUOTE || !!c.QuoteDetails
}

export const findEntityType = (id: string, candidates: Array<Contract | FullContract | undefined>): number | undefined => {
    const match = candidates.find((candidate) => candidate?.Id === id)
    if (!match) {
        return undefined
    }
    return isQuote(match) ? ENTITY_TYPE_QUOTE : ENTITY_TYPE_CONTRACT
}

export const isNotAQuote = (error: unknown): boolean => isAxiosError(error) && error.response?.status === 404
